import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import {
  Box,
  Button,
  CardMedia,
  FormControl,
  Icon,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { generateResponsiveStyle } from "utils/modalStyle";

// @mui icons
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CommonLayout from "components/CommonLayout";

// Images
import bgImage from "assets/images/background.png";
import product1 from "assets/images/product1.png";
import userPlaceholder from "assets/images/user_placeholder.png";
import pdf from "assets/images/pdf.png";

//form
import * as Yup from "yup";
import { isNaN, useFormik } from "formik";
import { removeFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";
import { useAppDispatch } from "hooks/store";
import useAuth from "hooks/useAuth";
import ShowToast from "components/MDToast";
import OTPInput from "react-otp-input";
import { setCredentials } from "reducers/authSlice";
import { useVerifyEmailPhoneMutation } from "services/auth";
import { useOtpVerifyMutation } from "services/auth";
import { useResendOtpMutation } from "services/auth";
import { useUpdateProfileMutation } from "services/auth";
import { Uploadpdf } from "utils/mediaUpload";
import { UploadMedia } from "utils/mediaUpload";
import { isString } from "utils/validations";
import { isNumber } from "utils/validations";
import PhoneInput from "react-phone-input-2";
import AddIcon from "@mui/icons-material/Add";
import { getFromStorage } from "helpers";
import useTranslation from "hooks/Translation";

const otpStyle = {
  width: "50px",
  height: "50px",
  "box-sizing": "border-box",
  margin: "0 auto",
  backgroundColor: "transparent",
  borderWidth: 0.5,
  borderRadius: 4,
};

const ProfileSetup = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  console.log(state, "-----<<<<<<");
  const user = useAuth();
  const getLang = getFromStorage(STORAGE_KEYS.language);

  const dispatch = useAppDispatch();
  const [verifyEmailPhone] = useVerifyEmailPhoneMutation();
  const [verifyOtp] = useOtpVerifyMutation();
  const [resendOtp] = useResendOtpMutation();
  const [updateProfile] = useUpdateProfileMutation();

  const style = generateResponsiveStyle();
  const [image, setImage] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(false);
  const [countDown, setCountDown] = useState(59);
  const [resend, setResend] = useState(false);
  const [preview, setPreview] = useState("");
  const [myImages, setMyImages] = useState([]);
  const [document, setDocument] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);
  const [profileId, setProfileId] = useState("");
  const [documentId, setDocumentId] = useState(0);

  const handleSubmit = async (type) => {
    if (otp?.length === 4) {
      setError(false);
      const body = {
        ...(state?.type === "phone"
          ? { email: formik.values.email }
          : { phone_no: formik.values.phone_no }),
        ...(state?.type === "email"
          ? { country_code: formik.values.country_code }
          : {}),
        otp: otp,
      };

      try {
        const res = await verifyOtp(body).unwrap();
        if (res?.status === 200) {
          setOpen(false);
          setResend(false);
          if (state?.type === "email") {
            setPhoneVerified(true);
          } else {
            setEmailVerified(true);
          }
        }
      } catch (error) {
        if (error?.data?.message) {
          ShowToast(error?.data?.message || "", "error");
        }
      }
    } else {
      setError(true);
    }
  };

  const handleIndustryChange = (event) => {
    formik.setFieldValue("industry_type", event.target.value);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone_no: "",
      country_code: "",
      // business_registration:1,
      profile_picture: "",
      industry_type: "",
      business_name: "",
      pin_code: "",
      city: "",
      full_name: "",
      business_address: "",
      password: "",
      passwordConfirmation: "",
      ac_number: "",
      ac_holder_name: "",
      swift_code: "",
      bank_name: "",
      branch_name: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(t.error.required)
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          t.error.validEmail
        ),
      full_name: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),

      industry_type: Yup.string().required(t.error.required),
      // dob: Yup.string().required(translation.error.dobReq),
      business_name: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),

      pin_code: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),
      city: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),

      business_address: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),

      password: Yup.string()
        .label("Password")
        .required(t.error.required)
        .matches(
          /(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/,
          t.error.passValid
        ),

      passwordConfirmation: Yup.string()
        .oneOf([Yup.ref("password")], t.error.passMatch)
        .required(t.error.required),

      ac_number: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),
      ac_holder_name: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),
      swift_code: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),
      bank_name: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),
      branch_name: Yup.string()
        .required(t.error.required)
        .min(3, t.error.minValidation)
        .max(100, t.error.max100),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);

      setLoading(true);

      setLoading(false);
      if (!document?.length) {
        setError(true);
        return;
      }

      setError(false);
      let body = {
        email: values.email,
        phone_no: values.phone_no,
        country_code: values.country_code,
        business_registration: documentId,
        profile_picture: profileId,
        business_name: values.business_name,
        full_name: values.full_name,
        industry_type: Number(values.industry_type),
        pin_code: values.pin_code,
        city: values.city,
        business_address: values.business_address,
        password: values.password,
        ac_number: values.ac_number,
        ac_holder_name: values.ac_holder_name,
        swift_code: values.swift_code,
        bank_name: values.bank_name,
        branch_name: values.branch_name,
        latitude: "",
        longitude: "",
      };

      console.log(body, "body");

      if (!emailVerified) {
        ShowToast("Please verify your email address", "error");
        return;
      } else {
        try {
          const response = await updateProfile(body).unwrap();
          if (response?.status === 200) {
            removeFromStorage(STORAGE_KEYS.token);
            dispatch(
              setCredentials({
                user: null,
                token: null,
              })
            );

            // if (response?.data?.isEmailVerify) {
            ShowToast(t.main.profileCreated);
            navigate("/", { replace: true, state: "profile" });
            // }
          }
        } catch (error) {
          ShowToast(error?.data?.message || "", "error");
        }
      }
    },
  });

  const handleChangePhone = (phone, country) => {
    formik.setFieldValue("phone_no", phone?.replace(country.dialCode, ""));
    formik.setFieldValue(
      "country_code",
      country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
    );
  };

  const sendOtp = async () => {
    if (formik.touched.email && formik.errors.email) {
      ShowToast("Please enter a valid email", "error");
      return;
    }

    const body = {
      email: formik.values.email,
      phone_no: formik.values.phone_no,
      country_code: formik.values.country_code,
    };

    try {
      const response = await verifyEmailPhone(body).unwrap();
      if (response?.status === 200) {
        if (resend) {
          ShowToast("Otp sent successfully");
        }
        setOpen(true);
        setCountDown(59);
      }
    } catch (error) {
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const handleProfileUpload = async (event, key) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";

    // Check if a file is selected
    if (file) {
      // Check if the selected file is an image
      if (file.type.startsWith("image/")) {
        const res = await UploadMedia(file);
        if (res?.status === 200) {
          if (key === "profile") {
            formik.setFieldValue("profile_picture", res?.data[0]?.media_url);
            setProfileId(res?.data[0]?.id);
          }
        } else {
          ShowToast(res?.message, "error");
        }
      } else {
        // Display an error message for non-image files
        ShowToast("Please select a valid image file (png or jpeg).", "error");
      }
    }
  };

  const handleImageUpload = async (event) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        setDocument(null);
        return;
      }

      let res;
      if (file.type === "application/pdf") {
        res = await Uploadpdf(file);
        if (res?.status === 200) {
          setDocument(res?.data?.[0]?.media_url); // Assuming pdfUrl is the URL of the uploaded PDF
          setDocumentId(res?.data?.[0]?.id);
        } else {
          ShowToast(res?.message);
        }
      } else {
        res = await UploadMedia(file);
        if (res?.status === 200) {
          setDocument(res?.data?.[0]?.media_url); // Assuming image is the URL of the uploaded image
          setDocumentId(res?.data?.[0]?.id);
        } else {
          ShowToast(res?.message, "error");
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      ShowToast("Error uploading file. Please try again.", "error");
    }
  };

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    console.log(token);

    if (state) {
      if (state?.type === "email") {
        formik.setFieldValue("email", state?.key);
        setEmailVerified(true);
      } else {
        formik.setFieldValue("phone_no", state.key);
        formik.setFieldValue("country_code", state.countryCode);
        setPhoneVerified(true);
      }
    }
  }, [state]);

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    const data = getFromStorage(STORAGE_KEYS.userData);

    let parsedData = null;
    try {
      parsedData = JSON.parse(data); // Parse only if it's a valid JSON string
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
    console.log(token);

    if (token) {
      dispatch(
        setCredentials({
          user: parsedData || "",
          token: token,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (open) {
      if (countDown > 0) {
        setTimeout(() => {
          setCountDown(countDown - 1);
        }, 1000);
      } else {
        setCountDown(0);
      }
    }
  }, [countDown, open]);

  return (
    <CommonLayout image={bgImage}>
      <Card sx={{ marginTop: 10, marginBottom: 5 }}>
        <MDBox
          // variant="gradient"
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          sx={{ display: "flex", justifyContent: "space-between" }}
          // textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {t.main.profileSetup}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {/* <Typography className="custom_label">Image</Typography> */}
                {formik.values.profile_picture ? (
                  <div className="upload_image_preview">
                    <CardMedia
                      component="img"
                      image={formik.values.profile_picture}
                      alt="photo"
                    />
                    <CancelIcon
                      onClick={() => {
                        formik.setFieldValue("profile_picture", "");
                      }}
                    />
                  </div>
                ) : (
                  <Box className="upload_image">
                    <label htmlFor="icon-button-file">
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{
                          accept: ".png, .jpg, .jpeg, .svg",
                        }}
                        onChange={(e) => handleProfileUpload(e, "profile")}
                      />

                      <Button component="span" className="upload_image_btn">
                        <img src={userPlaceholder} alt="" />
                        <CameraAltIcon />
                      </Button>
                    </label>
                  </Box>
                )}
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.fullName} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.fullName}
                    variant="outlined"
                    fullWidth
                    name="full_name"
                    id="full_name"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.full_name}
                    helperText={
                      formik.touched.full_name && formik.errors.full_name
                    }
                    error={formik.touched.full_name && formik.errors.full_name}
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.businessName} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.businessName}
                    variant="outlined"
                    fullWidth
                    name="business_name"
                    id="business_name"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.business_name}
                    helperText={
                      formik.touched.business_name &&
                      formik.errors.business_name
                    }
                    error={
                      formik.touched.business_name &&
                      formik.errors.business_name
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDTypography variant="subtitle2" className="custom_label">
                  {t.main.industryType} *
                </MDTypography>
                <FormControl fullWidth>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    displayEmpty
                    value={formik.values.industry_type}
                    onChange={handleIndustryChange}
                    error={
                      formik.touched.industry_type &&
                      formik.errors.industry_type
                    }
                    sx={{
                      border:
                        formik.touched.industry_type &&
                        formik.errors.industry_type
                          ? "1px solid red"
                          : "1px solid grey", // Add a custom border color
                      borderRadius: "6px", // Optional: Add border radius for styling
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Adjust border color for the outlined variant
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "grey", // Border color when focused
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t.main.select}
                    </MenuItem>

                    <MenuItem value={"1"}>{t.main.retailer}</MenuItem>
                    <MenuItem value={"2"}>{t.main.wholeSaler}</MenuItem>
                    <MenuItem value={"3"}>{t.main.distributor}</MenuItem>
                  </Select>
                </FormControl>
                {formik.touched.industry_type && formik.errors.industry_type ? (
                  <MDTypography className="err_msg">
                    {formik.touched.industry_type &&
                      formik.errors.industry_type}
                  </MDTypography>
                ) : (
                  ""
                )}
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.address} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.address}
                    variant="outlined"
                    fullWidth
                    name="business_address"
                    id="business_address"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.business_address}
                    helperText={
                      formik.touched.business_address &&
                      formik.errors.business_address
                    }
                    error={
                      formik.touched.business_address &&
                      formik.errors.business_address
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.pinCode} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.pinCode}
                    variant="outlined"
                    fullWidth
                    name="pin_code"
                    id="pin_code"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isNumber(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.pin_code}
                    helperText={
                      formik.touched.pin_code && formik.errors.pin_code
                    }
                    error={formik.touched.pin_code && formik.errors.pin_code}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.city} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.city}
                    variant="outlined"
                    fullWidth
                    name="city"
                    id="city"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.city}
                    helperText={formik.touched.city && formik.errors.city}
                    error={formik.touched.city && formik.errors.city}
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.email} *
                  </MDTypography>
                  <div style={{ position: "relative" }}>
                    <MDInput
                      disabled={
                        state?.type === "email" ||
                        user?.otp_verification ||
                        emailVerified
                          ? true
                          : false
                      }
                      type="text"
                      placeholder={t.main.email}
                      variant="outlined"
                      fullWidth
                      name="email"
                      id="email"
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      helperText={formik.touched.email && formik.errors.email}
                      error={formik.touched.email && formik.errors.email}
                    />
                    {formik.values.email &&
                    state?.type === "phone" &&
                    !emailVerified ? (
                      <div className="verifydiv">
                        <h4 onClick={sendOtp}>Verify</h4>
                      </div>
                    ) : emailVerified ? (
                      <div
                        className="verified"
                        style={{
                          position: "absolute",
                          ...(getLang === "ar"
                            ? { left: "10px" }
                            : { right: "10px" }),
                        }}
                      >
                        <CheckCircleOutlineIcon />
                      </div>
                    ) : null}
                  </div>
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.phoneOpt}
                  </MDTypography>
                  <div style={{ position: "relative" }}>
                    <PhoneInput
                      disabled={
                        state?.type === "phone" || phoneVerified ? true : false
                      }
                      country={"ae"}
                      placeholder="0 (000) 000-000"
                      enableSearch={false}
                      id="phone"
                      name="phone"
                      inputStyle={{
                        width: "100%",
                        backgroundColor: "transparent",
                        height: "45px",
                        direction: getLang === "ar" ? "rtl" : "ltr",
                        paddingRight: getLang === "ar" ? "80px" : "0px",
                      }}
                      containerClass={`phone-input-container ${
                        formik.touched.phone_no && formik.errors.phone_no
                          ? "phone-input-error"
                          : ""
                      }`}
                      buttonStyle={{
                        marginRight: getLang === "ar" ? "40px" : "0px",
                      }}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      onBlur={formik.handleBlur}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent default behavior (form submission)
                          formik.handleSubmit(); // Manually submit the form
                        }
                      }}
                      value={
                        formik.values.country_code + formik.values.phone_no
                      }
                    />

                    {formik.touched.phone_no && formik.errors.phone_no ? (
                      <MDTypography variant="body1" className="err_msg">
                        {formik.touched.phone_no && formik.errors.phone_no}
                      </MDTypography>
                    ) : (
                      ""
                    )}
                  </div>
                </MDBox>
              </Grid>

              <Grid item xs={12}>
                <MDTypography variant="h6">{t.main.bankDetails}</MDTypography>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.bankName} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.bankName}
                    variant="outlined"
                    fullWidth
                    name="bank_name"
                    id="bank_name"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.bank_name}
                    helperText={
                      formik.touched.bank_name && formik.errors.bank_name
                    }
                    error={formik.touched.bank_name && formik.errors.bank_name}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.bankBranch} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.bankBranch}
                    variant="outlined"
                    fullWidth
                    name="branch_name"
                    id="branch_name"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.branch_name}
                    helperText={
                      formik.touched.branch_name && formik.errors.branch_name
                    }
                    error={
                      formik.touched.branch_name && formik.errors.branch_name
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.holder} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.holder}
                    variant="outlined"
                    fullWidth
                    name="ac_holder_name"
                    id="ac_holder_name"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isString(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.ac_holder_name}
                    helperText={
                      formik.touched.ac_holder_name &&
                      formik.errors.ac_holder_name
                    }
                    error={
                      formik.touched.ac_holder_name &&
                      formik.errors.ac_holder_name
                    }
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.accNumber} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.accNumber}
                    variant="outlined"
                    fullWidth
                    name="ac_number"
                    id="ac_number"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isNumber(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.ac_number}
                    helperText={
                      formik.touched.ac_number && formik.errors.ac_number
                    }
                    error={formik.touched.ac_number && formik.errors.ac_number}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.swift} *
                  </MDTypography>
                  <MDInput
                    type="text"
                    placeholder={t.main.swift}
                    variant="outlined"
                    fullWidth
                    name="swift_code"
                    id="swift_code"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else if (isNumber(val.target.value)) {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.swift_code}
                    helperText={
                      formik.touched.swift_code && formik.errors.swift_code
                    }
                    error={
                      formik.touched.swift_code && formik.errors.swift_code
                    }
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12}>
                <MDTypography variant="h6">{t.main.passSetup}</MDTypography>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.enterPass} *
                  </MDTypography>
                  <MDInput
                    placeholder={t.main.enterPass}
                    variant="outlined"
                    fullWidth
                    name="password"
                    id="password"
                    type={showPassword ? "text" : "password"}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                    error={formik.touched.password && formik.errors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment className="eye_btn" position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <MDBox>
                  <MDTypography variant="subtitle2" className="custom_label">
                    {t.main.reEnterPAss} *
                  </MDTypography>
                  <MDInput
                    placeholder={t.main.reEnterPAss}
                    variant="outlined"
                    fullWidth
                    name="passwordConfirmation"
                    id="passwordConfirmation"
                    type={confirmShowPassword ? "text" : "password"}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.passwordConfirmation}
                    helperText={
                      formik.touched.passwordConfirmation &&
                      formik.errors.passwordConfirmation
                    }
                    error={
                      formik.touched.passwordConfirmation &&
                      formik.errors.passwordConfirmation
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment className="eye_btn" position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() =>
                              setConfirmShowPassword(!confirmShowPassword)
                            }
                            onMouseDown={() =>
                              setConfirmShowPassword(!confirmShowPassword)
                            }
                            edge="end"
                          >
                            {confirmShowPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>
              </Grid>

              <Grid item xs={12}>
                <MDTypography variant="h6">{t.main.businessReq}</MDTypography>
              </Grid>
            </Grid>

            <Grid item xs={4}>
              {document ? (
                document.endsWith(".pdf") ? (
                  <div className="upload_image_preview2">
                    <CardMedia
                      component="img"
                      image={pdf}
                      alt="photo"
                      sx={{ width: 200, height: 200, objectFit: "contain" }}
                      onClick={() => window.open(document)}
                    />
                    <CancelIcon
                      onClick={() => setDocument(null)}
                      color="error"
                    />
                  </div>
                ) : (
                  <div className="upload_image_preview2">
                    <CardMedia
                      component="img"
                      image={document}
                      alt="photo"
                      sx={{ width: 200, height: 200 }}
                    />
                    <CancelIcon
                      onClick={() => setDocument(null)}
                      color="error"
                    />
                  </div>
                )
              ) : (
                <Box className="upload_image_bnr">
                  <label htmlFor="icon-button-file-vdo">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file-vdo"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg,application/pdf",
                      }}
                      onChange={(e) => handleImageUpload(e)}
                    />
                    <Button component="span" className="upload_image_btn">
                      <AddIcon />
                    </Button>
                  </label>
                </Box>
              )}
              {error && !document?.length ? (
                <MDTypography className="err_msg">
                  {t.error.docReq}
                </MDTypography>
              ) : (
                ""
              )}
            </Grid>

            <MDButton
              // onClick={() => navigate("/dashboard")}
              variant="gradient"
              color="success"
              type="submit"
              sx={{ marginTop: 4 }}
            >
              {t.main.save}
            </MDButton>
          </form>
        </MDBox>
      </Card>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setResend(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="auth_parnt">
            <div className="auth_left">
              <MDTypography variant="h4" sx={{ textAlign: "center" }}>
                {t.main.enterOtp}
              </MDTypography>
              <Box sx={{ paddingBottom: 5 }}></Box>
              <FormControl className="opt_fields" sx={{ width: "100%" }}>
                <OTPInput
                  containerStyle={{ width: "70%", margin: "auto" }}
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  renderInput={(props) => <input {...props} />}
                  inputStyle={otpStyle}
                  inputType="tel"
                />
                <br />
                {error && otp.length !== 4 ? (
                  <h6 className="err_msg" style={{ textAlign: "center" }}>
                    Otp is required
                  </h6>
                ) : (
                  ""
                )}
              </FormControl>

              <Box sx={{ pt: 3 }}>
                <MDButton
                  variant="gradient"
                  color="success"
                  fullWidth
                  onClick={() => handleSubmit("phone")}
                >
                  Verify
                </MDButton>
              </Box>
              {countDown === 0 ? (
                <MDBox
                  sx={{
                    textAlign: "center",
                    pt: 2,
                  }}
                >
                  <MDTypography
                    variant="body2"
                    sx={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                      setResend(true);
                      sendOtp();
                    }}
                  >
                    Resend otp
                  </MDTypography>
                </MDBox>
              ) : (
                <Box>
                  <MDTypography
                    variant="body2"
                    sx={{
                      color: "grey",
                      pt: 2,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Code will expire in{" "}
                    <p
                      style={{
                        margin: 0,

                        paddingLeft: 3,
                        minWidth: 70,
                      }}
                    >
                      {countDown < 10
                        ? `00: 0${countDown}`
                        : `00: ${countDown}`}
                    </p>
                  </MDTypography>
                </Box>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </CommonLayout>
  );
};

export default ProfileSetup;
